module.exports = __webpack_public_path__ + "assets/img/poster-desk.e00b6a6b.jpg";